// Action type constants for the Pricing Analysis (PEL) feature.
// In the target repo these can live here or be merged into src/actions/types.js.
export const PEL_FETCH_DASHBOARD = 'PEL_FETCH_DASHBOARD';
export const PEL_FETCH_MAP = 'PEL_FETCH_MAP';
export const PEL_FETCH_LEVEL = 'PEL_FETCH_LEVEL';          // payload keyed by level id (l0..l5)
export const PEL_FETCH_GROWTH = 'PEL_FETCH_GROWTH';
export const PEL_FETCH_CTS_LTV = 'PEL_FETCH_CTS_LTV';
export const PEL_FETCH_BENCHMARKING = 'PEL_FETCH_BENCHMARKING';
export const PEL_FETCH_AI_INSIGHTS = 'PEL_FETCH_AI_INSIGHTS';
export const PEL_FETCH_CLIENTS = 'PEL_FETCH_CLIENTS';
export const PEL_RUN_SIMULATION = 'PEL_RUN_SIMULATION';
export const PEL_SET_ERROR = 'PEL_SET_ERROR';
